import { localStorageGet, localStorageSet, removeItem } from './index'

const TOUR_BOOK_INFO = 'TOUR_BOOK_INFO'
const TOUR_LOGIN_INFO = 'TOUR_LOGIN_INFO'
const TOUR_PAGE_CONFIG = 'TOUR_PAGE_CONFIG'
const TOUR_DICT_DATA = 'TOUR_DICT_DATA'
const TOUR_PRODUCT_INFO = 'TOUR_PRODUCT_INFO'
const COUNTRY_CODE = 'COUNTRY_CODE'
const INPUT_INFO_DATA = 'INPUT_INFO_DATA'
const PAGE_FROM_PARAM = 'PAGE_FROM_PARAM'
const PAGE_HASH = 'PAGE_HASH'
const LAST_VIEW_PARAM = 'LAST_VIEW_PARAM'


/*******
 * 预订信息
 */
//保存预订信息
export function setBookInfo(data, expireTime) {
    localStorageSet(TOUR_BOOK_INFO, data, expireTime)
}

//获取预订信息
export function getBookInfo() {
    return localStorageGet(TOUR_BOOK_INFO)
}

//移除预订信息
export function removeBookInfo() {
    removeItem(TOUR_BOOK_INFO)
}

/**********
 * login
 * **********/
export function setLoginInfo(data, expireTime) {
    localStorageSet(TOUR_LOGIN_INFO, data, expireTime)
}
//获登录
export function getLoginInfo() {
    return localStorageGet(TOUR_LOGIN_INFO)
}
//获登录
export function removeLoginInfo() {
    return removeItem(TOUR_LOGIN_INFO)
}

/**********
 * 
 * **********/
export function setPageConfig(data, expireTime) {
    localStorageSet(TOUR_PAGE_CONFIG, data, expireTime)
}
//获登录
export function getPageConfig() {
    return localStorageGet(TOUR_PAGE_CONFIG)
}
//获登录
export function removePageConfig() {
    return removeItem(TOUR_PAGE_CONFIG)
}

/**********
 *  dict data
 * **********/
export function setDictData(data, expireTime) {
    localStorageSet(TOUR_DICT_DATA, data, expireTime)
}
//
export function getDictData() {
    return localStorageGet(TOUR_DICT_DATA)
}
//
export function removeDictData() {
    return removeItem(TOUR_DICT_DATA)
}


/*******
 * 产品信息
 */
//保存预订信息
export function setProductInfo(data, expireTime) {
    localStorageSet(TOUR_PRODUCT_INFO, data, expireTime)
}

//获取预订信息
export function getProductInfo() {
    return localStorageGet(TOUR_PRODUCT_INFO)
}

//移除预订信息
export function removeProductInfo() {
    removeItem(TOUR_PRODUCT_INFO)
}

/*******
 * 国家码
 */
export function setCountryCodeStore(data, expireTime) {
    localStorageSet(COUNTRY_CODE, data, expireTime)
}

export function getCountryCodeStore() {
    return localStorageGet(COUNTRY_CODE)
}

export function removeCountryCodeStore() {
    removeItem(COUNTRY_CODE)
}


/*******
 * 保存填写的信息
 */
export function setInputFormDataStore(data, expireTime) {
    localStorageSet(INPUT_INFO_DATA, data, expireTime)
}

export function getInputFormDataStore() {
    return localStorageGet(INPUT_INFO_DATA)
}

export function removeInputFormDataStore() {
    removeItem(INPUT_INFO_DATA)
}


/*******
 * 来源信息
 */
export function setFromParamStore(data, expireTime) {
    localStorageSet(PAGE_FROM_PARAM, data, expireTime)
}

export function getFromParamStore() {
    return localStorageGet(PAGE_FROM_PARAM)
}

export function removeFromParamStore() {
    removeItem(PAGE_FROM_PARAM)
}

/*******
 * 保存页面
 */
export function setPageHashStore(data, expireTime) {
    localStorageSet(PAGE_HASH, data, expireTime)
}

export function getPageHashStore() {
    return localStorageGet(PAGE_HASH)
}

export function removePageHashStore() {
    removeItem(PAGE_HASH)
}

/*******
 * 保存页面及参数
 */
export function setLastViewParamStore(data, expireTime) {
    localStorageSet(LAST_VIEW_PARAM, data, expireTime)
}

export function getLastViewParamStore() {
    return localStorageGet(LAST_VIEW_PARAM)
}

export function removeLastViewParamStore() {
    removeItem(LAST_VIEW_PARAM)
}